import React from "react";

import { Card, Col } from "react-bootstrap";

function FounderBio({ bio }) {
  return (
    <Col>
      <Card className="border-0">
        <Card.Body>
          <Card.Text>{bio}</Card.Text>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default FounderBio;
